import { api } from '../api/client';

export interface DingtalkPublicConfig {
  corpId: string | null;
  configured: boolean;
  pcLoginAvailable: boolean;
}

/**
 * 构建期闸门：保证 .env.production 的 VITE_DINGTALK_CORP_ID 打进产物，
 * 供 scripts/verify-frontend-build.sh 检查。运行时免登仍以 /auth/dingtalk/config 为准。
 */
export const BUILD_TIME_DINGTALK_CORP_ID = String(
  (import.meta.env.VITE_DINGTALK_CORP_ID as string | undefined) || '',
);

/** 运行时拉当前租户 corpId；仅本地 dev 可 fallback 到 VITE_DINGTALK_CORP_ID */
export async function resolveDingtalkCorpId(): Promise<string> {
  try {
    const cfg = (await api.get('/auth/dingtalk/config')) as DingtalkPublicConfig;
    if (cfg?.corpId) return cfg.corpId;
  } catch {
    /* 子域/API 不可用 */
  }
  if (import.meta.env.DEV) {
    return (import.meta.env.VITE_DINGTALK_CORP_ID as string | undefined) || '';
  }
  // 生产多租户：构建期 corpId 可能是别家企业的，禁止当作兜底（会导致授权白屏）
  return '';
}
